module.exports = __webpack_public_path__ + "img/bg.0f2f2dbc.png";